import SettingBase from '../settings/util/SettingBase'

class ResetAtmCodeController extends SettingBase {
    /*@ngInject*/
    constructor($state) {
        super();
        this.$state = $state;
        this.id = "reset-atm-code";
        this.acl = {};
        this.hasACL = {};
        
    }
    $onInit() {
        super.$onInit()
        for (let key in this.acl['setting-' + this.id]) {
          this.hasACL[this.acl['setting-' + this.id][key]] = true;
        }
    }
}

export default ResetAtmCodeController;


// WEBPACK FOOTER //
// ./client/app/components/reset_atm_code/reset_atm_code.controller.js